@if (group) {
  <div [formGroup]="group">
    <mat-form-field>
      <mat-select formControlName="value" placeholder="Choose one option">
        @if (allowEmptyValue) {
          <mat-option>--</mat-option>
        }
        @for (option of group.get('allowedValues')?.value; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
      @if (showHint) {
        <mat-hint>{{ group.get('customFieldType')?.value | customFieldType }}</mat-hint>
      }
    </mat-form-field>
  </div>
}
